import { render, staticRenderFns } from "./SleepAlarm.vue?vue&type=template&id=c05607ac&scoped=true&"
import script from "./SleepAlarm.vue?vue&type=script&lang=js&"
export * from "./SleepAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05607ac",
  null
  
)

export default component.exports